<template>
    <div>
        <div class="top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户概览</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page-content p20">
            <div class="content-box p20 bg_fff " style="text-align: left;">
                <h2>提现账号管理</h2>
                <div class="count-info">
                    <div class="item"><span class="name">账户类型:</span><span class="con">微信</span></div>
                    <div class="item"><span class="name">账号:</span><span class="con">{{userinfo.wx}}</span></div>
                    <div class="item"><span class="name">账户名称:</span><span class="con">{{userinfo.realname}}</span></div>
                    <div class="item"><span class="name">绑定手机号:</span><span class="con">{{userinfo.mobile}}</span></div>
                </div>
                <div class="btn">
                    <el-button @click="back">返回</el-button>
                    <el-button type="primary" v-if="userinfo.wx" @click="dialogVisible=true">更改提现账号</el-button>
                    <el-button type="primary" v-else @click="dialogVisible=true">创建提现账号</el-button>
                </div>
            </div>
        </div>
        <el-dialog
                :title="userinfo.wx?'更改提现账号':'创建提现账号'"
                :visible.sync="dialogVisible"
                width="500px"
                >
            <el-form  label-width="80px" style="text-align: left;">
                <el-form-item label="手机号">
                    <el-input type="input" v-model="mobile" maxlength="11" placeholder="请输入手机号" style="margin-bottom:20px ;"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input type="input" v-model="code" maxlength="30" placeholder="请输入验证码" style="margin-bottom:20px ;"><template slot="append" ><div @click="getCode" style="cursor: pointer">{{count==0?'获取验证码':'重新获取('+count+'s)'}}</div></template></el-input>
                </el-form-item>
                <el-form-item label="微信号">
                    <el-input type="input" v-model="wxCode" maxlength="30" placeholder="请输入微信号" style="margin-bottom:20px ;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogVisible=false">取消</el-button>
                    <el-button type="primary" @click="subWx">{{userinfo.wx?'立即修改':'立即创建'}}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {getUserinfo} from '../../api/role'
    import {getCode,bandWx} from '../../api/index'
    export default {
        name: "count",
        data(){
            return{
                dialogVisible:false,
                timer:'',
                count: '',//验证码倒计时
                isClick:true,
                userinfo:'',
                wxCode:'',
                mobile:'',
                code:'',
            }
        },
        mounted(){
            this.getUserinfo();
        },
        methods:{
            getUserinfo(){
                getUserinfo().then(res=>{
                    if(res.code==1){
                        this.userinfo=res.data;
                        this.mobile=this.userinfo.mobile
                    }
                })
            },
            getCode(){
                if(!this.isClick){
                    return;
                }
                if(!/^[1][0-9]{10}$/.test(this.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                getCode({
                    mobile:this.mobile
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('验证码发送成功');
                        this.isClick=false;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.isClick=true;
                                }
                            }, 1000)
                        }

                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            subWx(){
                if(!/^[1][0-9]{10}$/.test(this.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(!this.code){
                    this.$message.error('请输入验证码');
                    return;
                }
                if(!this.wxCode){
                    this.$message.error('请输入微信号');
                    return;
                }
                bandWx({
                    code:this.code,
                    mobile:this.mobile,
                    wx:this.wxCode
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('绑定成功');
                        this.dialogVisible=false;
                        this.getUserinfo();
                    }else{
                        this.$message.error(res.msg);
                    }
                })

            },
            back(){
                this.$router.push({path:'/withdraw/withdraw'})
            }
        }
    }
</script>

<style lang="scss" scoped>
.top{
    padding: 20px 0 0 20px;
}
    .count-info{
        .item{
            padding: 20px 0;
            .name{
                display: inline-block;
                width: 100px;
            }
            .con{
                display: inline-block;
                margin-left: 10px;
                width: 200px;
                border-bottom: 1px solid #eaeaea;
            }
        }
    }
</style>
